import type { Services } from "../data/services";
import { dueIn } from "../data/format";

/**
 * Executes an auto-execute data lookup against the in-bundle services and
 * formats a compact result line. Returns null for anything that isn't a data
 * getter — navigate offers are handled by the chat screen, not here.
 */
export async function runDataTool(name: string, services: Services): Promise<string | null> {
  const { academic, matching, reward, challenge } = services;

  switch (name) {
    case "getCourses": {
      const courses = await academic.getCourses();
      return courses
        .map((c) => `${c.code ?? c.id}: ${c.name} (${c.currentGrade?.toFixed(1) ?? "N/A"}%)`)
        .join("; ");
    }
    case "getAssignments": {
      const assignments = await academic.getAssignments();
      return assignments
        .filter((a) => a.status !== "graded" && a.status !== "submitted")
        .map((a) => `${a.title} — ${dueIn(a.dueDate)}`)
        .join("; ");
    }
    case "getGPA": {
      const gpa = await academic.getOverallGPA();
      return gpa.toFixed(2);
    }
    case "getMatches": {
      const matches = await matching.getMatches(0, 5);
      return matches
        .map((m) => `${m.user.displayName}: ${Math.round(m.overallScore * 100)}%`)
        .join("; ");
    }
    case "getBalance": {
      const balance = await reward.getBalance();
      return `${balance.balance} points, rank #${balance.rank ?? "—"}`;
    }
    case "getTodayChallenge": {
      const today = await challenge.getTodayChallenge();
      return `${today.prompt} (${today.submissionCount} submissions)`;
    }
    default:
      return null;
  }
}
